import TemplateView from 'picnic/core/views/Template';
import Template from 'app/cms/search/views/Tag.html';


class View extends TemplateView {

	get template() {
		return Template;
	}

}

export default View;
